import type { AxiosResponse } from 'axios';
import axiosInstance from './axiosInstance';
const baseUrl = `${SUPP_ADMIN_BASE_URL}/supp-management`;

export interface GetBannerListParams {
  currentPage?: number;
  pageSize?: number;
}

export interface BannerItem {
  id: number;
  jumpType: number; // 0-链接，1-投票活动ID，2-contest列表，3-ai作图
  jumpContent: string;
  image: string; // 图片（英文版）
  imageJa: string; // 图片（日文版）
  status: number; // 0-下线，1-上线
  publishTime: string;
  updateUser: string;
}

export interface GetBannerListResponse {
  status: number;
  success: boolean;
  message: string;
  data: {
    total: number;
    currentPage: number;
    pageSize: number;
    records: BannerItem[];
  };
}

export interface SaveOrUpdateBannerParams {
  id?: number;
  jumpType: number;
  jumpContent: string;
  image: string;
  imageJa: string;
  sort: number; // 排序
  status: number;
  publishTime: string;
}

export interface CommonResponse {
  status: number;
  success: boolean;
  message: string;
  data: object;
}

export interface GetBannerDetailParams {
  id: number;
}

export interface BannerDetail {
  id: number;
  jumpType: number;
  jumpContent: string;
  image: string;
  imageJa: string;
  sort: number;
  status: number;
  publishTime: string;
}

export interface GetBannerDetailResponse {
  status: number;
  success: boolean;
  message: string;
  data: BannerDetail;
}

export interface BatchOfflineParams {
  idList: number[]; // 需要下线的 banner ids
}

/**
 * 列表
 * @param {*} params
 * @returns
 */
export function getBannerList(
  params: GetBannerListParams
): Promise<AxiosResponse<GetBannerListResponse>> {
  return axiosInstance.get(`${baseUrl}/banner/v1/list`, {
    params,
  });
}

/**
 * 新增编辑
 * @param {*} params
 * @returns
 */
export function saveOrUpdateBanner(
  params: SaveOrUpdateBannerParams
): Promise<AxiosResponse<CommonResponse>> {
  return axiosInstance.post(`${baseUrl}/banner/v1/addOrEdit`, params, {
    headers: {
      'Content-Type': 'application/json',
    },
  });
}

/**
 * 详情
 * @param {*} params
 * @returns
 */
export function getBannerDetail(
  params: GetBannerDetailParams
): Promise<AxiosResponse<GetBannerDetailResponse>> {
  return axiosInstance.get(`${baseUrl}/banner/v1/detail`, {
    params,
  });
}

/**
 * 批量下线
 * @param {*} params
 * @returns
 */
export function batchOfflineBanner(
  params: BatchOfflineParams
): Promise<AxiosResponse<CommonResponse>> {
  return axiosInstance.post(`${baseUrl}/banner/v1/batchOffline`, params, {
    headers: {
      'Content-Type': 'application/json',
    },
  });
}
